/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomPlaceCrossing,
    CustomPlaceCrossingFromJSON,
    CustomPlaceCrossingFromJSONTyped,
    CustomPlaceCrossingToJSON,
    LibModelsActivityInterval,
    LibModelsActivityIntervalFromJSON,
    LibModelsActivityIntervalFromJSONTyped,
    LibModelsActivityIntervalToJSON,
    MuDataProcessingJoinersCustomPlaceCrossingManual,
    MuDataProcessingJoinersCustomPlaceCrossingManualFromJSON,
    MuDataProcessingJoinersCustomPlaceCrossingManualFromJSONTyped,
    MuDataProcessingJoinersCustomPlaceCrossingManualToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomPlaceCrossingInDatabase
 */
export interface CustomPlaceCrossingInDatabase {
    /**
     * 
     * @type {LibModelsActivityInterval}
     * @memberof CustomPlaceCrossingInDatabase
     */
    activityInterval?: LibModelsActivityInterval;
    /**
     * 
     * @type {number}
     * @memberof CustomPlaceCrossingInDatabase
     */
    driverId?: number;
    /**
     * 
     * @type {CustomPlaceCrossing}
     * @memberof CustomPlaceCrossingInDatabase
     */
    customPlaceCrossing: CustomPlaceCrossing;
    /**
     * 
     * @type {MuDataProcessingJoinersCustomPlaceCrossingManual}
     * @memberof CustomPlaceCrossingInDatabase
     */
    manual?: MuDataProcessingJoinersCustomPlaceCrossingManual;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingInDatabase
     */
    id: string;
}

export function CustomPlaceCrossingInDatabaseFromJSON(json: any): CustomPlaceCrossingInDatabase {
    return CustomPlaceCrossingInDatabaseFromJSONTyped(json, false);
}

export function CustomPlaceCrossingInDatabaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomPlaceCrossingInDatabase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activityInterval': !exists(json, 'activity_interval') ? undefined : LibModelsActivityIntervalFromJSON(json['activity_interval']),
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'customPlaceCrossing': CustomPlaceCrossingFromJSON(json['custom_place_crossing']),
        'manual': !exists(json, 'manual') ? undefined : MuDataProcessingJoinersCustomPlaceCrossingManualFromJSON(json['manual']),
        'id': json['id'],
    };
}

export function CustomPlaceCrossingInDatabaseToJSON(value?: CustomPlaceCrossingInDatabase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activity_interval': LibModelsActivityIntervalToJSON(value.activityInterval),
        'driver_id': value.driverId,
        'custom_place_crossing': CustomPlaceCrossingToJSON(value.customPlaceCrossing),
        'manual': MuDataProcessingJoinersCustomPlaceCrossingManualToJSON(value.manual),
        'id': value.id,
    };
}


